import Dexie, { type Table } from "dexie";
import type { QueuedSale } from "./types.js";

/** Durable gate history: offline scans queue for upload; online/remote admissions are already synced. */
export interface GateScan { id?: number; code: string; gateCode: string; scannedAt: string; verdict: string; synced: 0 | 1; relay?: "pending" | "opened" | "simulated" | "uncertain" }
export interface MetaRow { key: string; value: unknown }

/**
 * The terminal's local store (IndexedDB). Sales are the offline queue and the tally source; meta caches the counter
 * configuration, the signed-in cashier, the hash-chain head, roll serials and the gate whitelist.
 */
export class PosDB extends Dexie {
  declare sales: Table<QueuedSale, string>;
  declare meta: Table<MetaRow, string>;
  declare scans: Table<GateScan, number>;

  constructor(name = "templeos-pos") {
    super(name);
    this.version(1).stores({ sales: "clientRef, &n, status, shiftId", meta: "key", scans: "++id, code, synced" });
  }

  async getMeta<T>(key: string): Promise<T | undefined> {
    return (await this.meta.get(key))?.value as T | undefined;
  }

  async setMeta(key: string, value: unknown): Promise<void> {
    await this.meta.put({ key, value });
  }
}

export const db = new PosDB();
